// copied from private/component-react/packages/image-experience-utils/src/get-cropped-image.js
import _ from 'underscore';

const AspectRatioTolerance = 0.01;

// Attention!!: DO NOT touch this algorithm unless sync with MT/DE.
// This logic is also implemented on DE side.
// originalBoxToCrop { SourceWidth, SourceHeight, SourceX, SourceY }
export const getCenterCroppedSettings = (originalBoxToCrop, aspectRatio) => {
  const {
    SourceWidth: centerContainerWidth,
    SourceHeight: centerContainerHeight,
  } = originalBoxToCrop;
  const originalRatio = centerContainerWidth / centerContainerHeight;
  const cropSettings = _.defaults({}, originalBoxToCrop);

  if (Math.abs(originalRatio - aspectRatio) > AspectRatioTolerance) {
    // If the target ratio is narrower than the original
    if (aspectRatio <= originalRatio) {
      // Use the same height, get the width from the original height
      const scaledSourceWidth = Math.round(cropSettings.SourceHeight * aspectRatio);

      // Since we use the full height, Y is still 0
      // Make sure we crop the middle section horionzontally
      const centerX =
        Math.round((cropSettings.SourceWidth - scaledSourceWidth) / 2) + cropSettings.SourceX;

      cropSettings.SourceWidth = scaledSourceWidth;
      cropSettings.SourceX = centerX;
    } else {
      // Use the same width, get the height from the original width
      const scaledSourceHeight = Math.round(cropSettings.SourceWidth / aspectRatio);

      // We use full width, X is 0.
      // Make sure we crop the middle section vertically
      const middleY = Math.round((
        cropSettings.SourceHeight - scaledSourceHeight) / 2) + cropSettings.SourceY;

      cropSettings.SourceHeight = scaledSourceHeight;
      cropSettings.SourceY = middleY;
    }
  }

  return cropSettings;
};

// todo: handle included/default option
export const getCentralCroppedPlacements = ({
  imageMeta,
  imageCropping,
  placementMetaList, // Array<UPAPlacementMeta>
  useOriginalImageSize = false,
}) => {
  const width = useOriginalImageSize ? imageMeta.originalWidth : imageMeta.width;
  const height = useOriginalImageSize ? imageMeta.originalHeight : imageMeta.height;
  const maxCropBox = imageCropping || {
    SourceWidth: width,
    SourceHeight: height,
    SourceX: 0,
    SourceY: 0,
  };
  const aspectRatios = _.pluck(placementMetaList, 'aspectRatio');
  const placementCroppings = _.map(aspectRatios, (ratio) => {
    const cropSettings = getCenterCroppedSettings(maxCropBox, ratio);
    return {
      placementCropping: cropSettings,
    };
  });
  return placementCroppings;
};

export const getCentralCroppedPlacementsFromOrigialImage = (imageMeta, aspectRatios) =>
  getCenterCroppedSettings(imageMeta, aspectRatios);
